// extracted by mini-css-extract-plugin
module.exports = {"aboutusMobile":"Index_aboutusMobile_1YKwr"};